import type {
  ChainEnvironments,
  ChainServices,
  ChainSwidge,
  ChainLimits,
} from './configTypes';

import { SWIDGE_PROVIDERS } from '../swidgeProviders';

/** Default limits that apply to all chains and environments unless overridden */
export const DEFAULT_CHAIN_LIMITS: ChainLimits = {
  minUsdWithdrawalAmount: 0.1,
  maxDailyWithdrawals: 100,
  maxDailyMoves: 100,
  maxUsdSwidgeFromAmount: 10000000,
  minUsdSwidgeFromAmount: 0.1,
  maxUsdSwidgePlatformFeePerBps: 5,
};

// Helpers used to populate/default parts of the chain config structure

export function defaultSwidge(input: Partial<ChainSwidge> = {}): ChainSwidge {
  return SWIDGE_PROVIDERS.reduce((acc, provider) => {
    acc[provider] = input[provider] || {};
    return acc;
  }, {} as ChainSwidge);
}

export function defaultServices(input: Partial<ChainServices> = {}) {
  const {
    codex = null,
    coingecko = null,
    coingeckoDex = null,
    defiLlama = null,
    qnStreams = null,
    safe = null,
    trm = null,
    zerion = null,
    alchemy = null,
    pimlico = null,
  } = input;

  return {
    codex,
    coingecko,
    coingeckoDex,
    defiLlama,
    qnStreams,
    safe,
    trm,
    zerion,
    alchemy,
    pimlico,
  };
}

export function defaultEnvironments(
  input: Partial<ChainEnvironments> | boolean = {}
): ChainEnvironments {
  return {
    dev: typeof input === 'boolean' ? input : !!input.dev || false,
    test: typeof input === 'boolean' ? input : !!input.test || false,
    staging: typeof input === 'boolean' ? input : !!input.staging || false,
    prod: typeof input === 'boolean' ? input : !!input.prod || false,
  };
}
